import React from 'react';
import { Checkbox } from '../../../components/ui/Checkbox';
import Icon from '../../../components/AppIcon';
import { useLanguage } from '../../../contexts/LanguageContext';

const EmployerTermsOfService = ({ formData, errors, onChange }) => {
  const { t } = useLanguage();

  return (
    <div className="space-y-6">
      <div>
        <h3 className="text-xl md:text-2xl font-semibold text-[#111827] mb-2">
          {t('legal.employerTermsTitle')}
        </h3>
        <p className="text-sm md:text-base text-[#6B7280]">
          {t('legal.employerTermsSubtitle')}
        </p>
      </div>

      <div className="bg-blue-50 border border-blue-200 rounded-xl p-6 space-y-4">
        <div className="flex items-start gap-3">
          <div className="flex-shrink-0 mt-1">
            <Icon name="DollarSign" size={24} color="#0025cc" />
          </div>
          <div>
            <h4 className="text-lg font-semibold text-[#111827] mb-2">
              {t('legal.hiringFeeTitle')}
            </h4>
            <p className="text-sm text-[#6B7280] leading-relaxed">
              {t('legal.hiringFeeDesc')}
            </p>
          </div>
        </div>
      </div>

      <div className="bg-amber-50 border border-amber-200 rounded-xl p-6 space-y-4">
        <div className="flex items-start gap-3">
          <div className="flex-shrink-0 mt-1">
            <Icon name="ShieldAlert" size={24} color="#D97706" />
          </div>
          <div>
            <h4 className="text-lg font-semibold text-[#111827] mb-2">
              {t('legal.antiCircumventionTitle')}
            </h4>
            <p className="text-sm text-[#6B7280] leading-relaxed">
              {t('legal.antiCircumventionDesc')}
            </p>
          </div>
        </div>
      </div>

      <div className="bg-gray-50 border border-gray-200 rounded-xl p-6 space-y-4">
        <div className="flex items-start gap-3">
          <div className="flex-shrink-0 mt-1">
            <Icon name="Shield" size={24} color="#6B7280" />
          </div>
          <div>
            <h4 className="text-lg font-semibold text-[#111827] mb-2">
              {t('legal.platformIntegrityTitle')}
            </h4>
            <p className="text-sm text-[#6B7280] leading-relaxed">
              {t('legal.platformIntegrityDesc')}
            </p>
          </div>
        </div>
      </div>

      <div className="pt-6 border-t border-[#E5E7EB] space-y-4">
        <Checkbox
          label={t('legal.acceptTerms')}
          checked={formData?.termsAccepted || false}
          onChange={(e) => onChange('termsAccepted', e?.target?.checked)}
          error={errors?.termsAccepted}
          required
        />

        <Checkbox
          label={t('legal.acceptHiringFee')}
          checked={formData?.hiringFeeAccepted || false}
          onChange={(e) => onChange('hiringFeeAccepted', e?.target?.checked)}
          error={errors?.hiringFeeAccepted}
          required
        />

        <Checkbox
          label={t('legal.acceptAntiCircumvention')}
          checked={formData?.antiCircumventionAccepted || false}
          onChange={(e) => onChange('antiCircumventionAccepted', e?.target?.checked)}
          error={errors?.antiCircumventionAccepted}
          required
        />
      </div>

      {(errors?.termsAccepted || errors?.hiringFeeAccepted || errors?.antiCircumventionAccepted) && (
        <div className="bg-red-50 border border-red-200 rounded-xl p-4 flex items-start gap-3">
          <Icon name="AlertCircle" size={20} color="#EF4444" />
          <span className="text-sm text-red-600">
            Please accept all terms to continue
          </span>
        </div>
      )}
    </div>
  );
};

export default EmployerTermsOfService;